import { mainLog } from './logger.js'
import sdkAdapter from './sdkAdapter.js';

const SDK_POLL_INTERVAL = 1000;
const SDK_POLL_MAX_ATTEMPTS = 30;

let eventQueueArray = [];
let pollingAttempts = 0;
let pollingTimeoutId = null;
let isPollingActive = false;

const enqueue = (eventType, properties) => {
  eventQueueArray.push({
    type: eventType,
    properties,
    timestamp: Date.now(),
  });
  mainLog('Event enqueued:', eventType, 'Queue size:', eventQueueArray.length);
};

const flush = () => {
  if (eventQueueArray.length === 0) {
    mainLog('[trackLayer:EventQueue] Event queue empty, no flush needed.');
    return;
  }

  if (!sdkAdapter.isReady()) {
    mainLog('[trackLayer:EventQueue] SDK not ready, keeping queued events.');
    return;
  }

  mainLog('[trackLayer:EventQueue] Flushing event queue:', eventQueueArray.length, 'events.');

  const eventsToSend = eventQueueArray.splice(0);
  eventsToSend.forEach(({type, properties}) => {
    sdkAdapter.track(type, properties);
  });
};

const startPolling = () => {
  if (isPollingActive) {
    mainLog('[trackLayer:EventQueue] Polling already active.');
    return;
  }

  isPollingActive = true;
  pollingAttempts = 0;
  mainLog('[trackLayer:EventQueue] 1. Starting SDK readiness polling...');

  const poll = () => {
    if (sdkAdapter.isReady()) {
      mainLog('[trackLayer:EventQueue] 2. SDK ready, flushing queue.');
      flush();
      stopPolling();
      return;
    }

    pollingAttempts++;
    if (pollingAttempts < SDK_POLL_MAX_ATTEMPTS) {
      pollingTimeoutId = setTimeout(poll, SDK_POLL_INTERVAL);
    } else {
      mainLog('[trackLayer:EventQueue] SDK readiness timeout reached - clearing queue.');
      clearQueue();
      stopPolling();
    }
  };

  poll();
};

const stopPolling = () => {
  if (pollingTimeoutId) {
    clearTimeout(pollingTimeoutId);
    pollingTimeoutId = null;
  }
  isPollingActive = false;
  pollingAttempts = 0;
  mainLog('[trackLayer:EventQueue] 3. SDK readiness polling stopped.');
};

const getQueueSize = () => eventQueueArray.length;

const clearQueue = () => {
  mainLog('[trackLayer:EventQueue] Event queue cleared.');
  eventQueueArray = [];
};

const eventQueue = {
  enqueue,
  flush,
  startPolling,
  stopPolling,
  getQueueSize,
  clearQueue,
};

export default eventQueue;